import { api } from './BaseApi'
import {
  IStandardAiDatasetBase,
  IStandardAiDatasetDto,
  IStandardAiDatasetResponse,
  IStandardAiDatasetRequest,
  IUploadStandardAiDatasetsRequest,
  IStandardAiDatasetUpdate,
} from './dto/StandardAiDatasetDto'
import { createQueryStringSmart } from 'utils/createQueryString'

export const standardAiDatasetApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getStandardAiDatasetList: builder.query<
      IStandardAiDatasetResponse,
      IStandardAiDatasetRequest | void
    >({
      query: (params) => ({
        url: `/upload_standart_ai_dataset/${createQueryStringSmart(
          params || null,
        )}`,
      }),
      providesTags: ['StandardAiDataset'],
    }),
    getStandardAiDatasetDetail: builder.query<
      IStandardAiDatasetDto,
      { id: number }
    >({
      query: ({ id }) => ({
        url: `/upload_standart_ai_dataset/${id}/`,
      }),
      providesTags: ['StandardAiDataset'],
    }),
    updateStandardAiDataset: builder.mutation<
      IStandardAiDatasetDto,
      { id: number; data: IStandardAiDatasetUpdate }
    >({
      query: ({ id, data }) => ({
        method: 'PATCH',
        url: `/upload_standart_ai_dataset/${id}/`,
        body: data,
      }),
      invalidatesTags: ['StandardAiDataset'],
    }),
    archiveMultipleStandardAiDatasets: builder.mutation<
      any,
      { standartAiDatasetIds: number[] }
    >({
      query: ({ standartAiDatasetIds }) => ({
        method: 'PATCH',
        url: `/upload_standart_ai_dataset/archive_standart_ai_datasets/`,
        body: { standartAiDatasetIds },
      }),
      invalidatesTags: ['StandardAiDataset'],
    }),
    uploadStandardAiDatasets: builder.mutation<
      any,
      FormData | IUploadStandardAiDatasetsRequest
    >({
      query: (body) => {
        return {
          method: 'POST',
          url: '/upload_standart_ai_dataset/upload_standart_ai_datasets/',
          body: body,
        }
      },
      invalidatesTags: ['StandardAiDataset'],
    }),
  }),
})

export const {
  useGetStandardAiDatasetListQuery,
  useGetStandardAiDatasetDetailQuery,
  useUpdateStandardAiDatasetMutation,
  useArchiveMultipleStandardAiDatasetsMutation,
  useUploadStandardAiDatasetsMutation,
} = standardAiDatasetApi
